import { render, staticRenderFns } from "./wei-ke-selector.vue?vue&type=template&id=2353f237"
import script from "./wei-ke-selector.vue?vue&type=script&lang=js"
export * from "./wei-ke-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports